import React from "react";

const ExportIcon = (props: any) => {
  const { stroke } = props;
  return (
    <svg
      {...props}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.33333 12.4158C2.7142 11.7833 2.24714 11.0181 1.96753 10.1783C1.68792 9.33847 1.60309 8.44604 1.71946 7.56858C1.83584 6.69113 2.15038 5.85167 2.63924 5.11378C3.12811 4.37589 3.77848 3.75893 4.54111 3.30963C5.30373 2.86032 6.1586 2.59046 7.04097 2.52048C7.92334 2.4505 8.81006 2.58224 9.63397 2.90572C10.4579 3.22919 11.1974 3.73592 11.7964 4.38753C12.3955 5.03914 12.8384 5.81853 13.0917 6.66667H14.5833C15.3879 6.66657 16.1712 6.92527 16.8175 7.40453C17.4638 7.8838 17.9388 8.55822 18.1723 9.32817C18.4059 10.0981 18.3856 10.9228 18.1144 11.6803C17.8433 12.4378 17.3357 13.0881 16.6667 13.535M10 10V17.5M10 10L13.3333 13.3333M10 10L6.66666 13.3333"
        stroke={stroke || "#374C44"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ExportIcon;
